import React, { useEffect } from "react";
import Banner from "../Components/Careers/Banner";
import SectionOne from "../Components/Careers/SectionOne";
import Cards from "../Components/Careers/Cards";
import { usePagesBanners } from "../Context/PagesBannersContext";

function Careers() {
  const { isBanner } = usePagesBanners();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);
  return (
    <div className="flex flex-col mx-[2rem] lg:mx-[7rem] md:mx-[4rem] items-center gap-7 overlay">
      <Banner isBanner={isBanner?.data[5]} />
      <SectionOne />
      <Cards />
    </div>
  );
}

export default Careers;
